<template>
  <div>
    <div style="position:fixed;top:90px;text-align:left;padding-left:50px;">
        <el-autocomplete
        v-model="query_painpoint"
        :fetch-suggestions="querySearchAsync"
        placeholder="在此输入您的痛点"
        @keyup.enter.native="queryPainPoint('fuzz')"
        style="width:300px;">
            <el-button slot="append" icon="el-icon-search" @click="queryPainPoint('fuzz')"></el-button>
        </el-autocomplete>
        <el-button type="primary" icon="el-icon-plus" @click="addPainPointQuestion" style="margin-left:10px;width;100px;">我要提问</el-button>
    </div>
    <div class="show_article_list">
        <el-card :key="index" v-for="(painspot, index) in painspot_list" style="margin-top:20px;width:800px;text-align:left;margin-left:50px;color:#606266;" @click.native="show_article_details(painspot)" class="card_css" shadow="hover">
          <div style="width:800px;">
            <div style="float:left;width:700px;" @click="show_article_details(painspot)" class="card_css">
              <p>{{ painspot.classification }} > {{ painspot.sub_class }}</p>
              <p style="font-weight:bold;font-size:22px;">{{ painspot.title }}</p>
              <p>{{ painspot.desc }}</p>
              <p>更新时间：{{ painspot.update_time }} | 评分：{{ painspot.rank }}</p>
            </div>
            <div style="float:left;width:80px;text-align:center;margin-top:10px;">
              <i class="el-icon-lock" v-if="painspot.islock=='是'" style="color:#909399;font-size:25px;" />
            </div>
          </div>
        </el-card>
        <el-dialog
          :visible.sync="dialogVisible"
          :fullscreen="true"
          :show-close="false"
          custom-class="fullscreen-dialog"
          @opened="handleDialogOpened"
          @open="handleDialogOpen"
          :close-on-click-modal="false"
          :close-on-press-escape="false">
          <template #title>
            <div class="dialog-header">
              <span style="font-size:25px;">{{ dialog_title }}</span>
              <el-button
                class="close-btn"
                icon="el-icon-close"
                @click="dialogVisible = false"
              ></el-button>
            </div>
          </template>

          <div class="dialog-content" v-if="dialog_show_type=='show_article_details'">
            <div v-show="content_permit==true" >
              <div style="text-align:left;margin-left:20px;">
                <span>更新时间：{{ cur_info.update_time }}</span><span style="margin-left:20px;">评分：{{ cur_info.avg_rating }}</span>
              </div>
              <div style="text-align:left;margin-left:20px;display:flex;margin-top:10px;">
                <el-button type="text" icon="el-icon-star-off" v-if="cur_info.isfavorite!='是'" @click="collect_painspot('add')">收藏</el-button>
                <el-button type="text" icon="el-icon-star-on" v-else @click="collect_painspot('remove')">收藏</el-button>
                <el-button type="text" icon="el-icon-s-comment" style="margin-left:10px;" @click="rating_painspot">评分</el-button>
                <el-rate
                v-model="cur_info.rating"
                show-score
                allow-half
                :disabled="cur_info.rating>0"
                text-color="#ff9900"
                style="margin-top:10px;margin-left:10px;"
                v-show="show_rating || cur_info.rating > 0"
                @change="submitRating">
                </el-rate>
                <el-button type="text" icon="el-icon-share" style="margin-left:10px;" @click="shareRichText">分享</el-button>
                <el-button type="text" icon="el-icon-edit" style="margin-left:10px;" @click="editRichText" v-if="!isEdit && logged_role=='expert'">编辑</el-button>
                <el-button type="text" icon="el-icon-setting" style="margin-left:10px;" @click="saveRichText" v-if="isEdit && logged_role=='expert'">保存</el-button>
              </div>
              <div class="ql-editor" v-html="content" style="margin-top:15px;" v-show="!isEdit"></div>
              <div class="editor-container" style="margin-top:15px;" v-show="isEdit && logged_role=='expert'">
                <quill-editor
                  v-model="content"
                  ref="myQuillEditor"
                  :options="editorOptions"
                />
              </div>
            </div>
            <div v-show="content_permit==false">
              <div style="width:100%;text-align:center;padding-top:20%;">
                <span style="font-size:22px;color:#F56C6C;font-weight:500;"><i class="el-icon-warning" /><span style="margin-left:5px;">对不起，你暂无权限访问此内容</span></span>
              </div>
            </div>
          </div>
          <div class="dialog-content" v-if="dialog_show_type=='add_pain_spot_question'">
            <div style="text-align:left;">
              <p style="padding-left:15px;color:#409EFF;font-weight:bold;font-size:15px;">温馨提示：在提问前先通过问题搜索或导航目录查看是否已有相似问题哦~</p>
              <el-form :model="form" label-width="120px" label-position="left" style="width:100%;margin-top:50px;" class="ql-editor">
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>问题标题</span>
                      </template>
                      <!-- <el-input v-model="form.title" placeholder="简明扼要地概括问题（如：关键人才离职率高怎么办？）"></el-input> -->
                      <el-autocomplete
                      v-model="form.title"
                      :fetch-suggestions="querySearchAsync"
                      placeholder="简明扼要地概括问题（如：关键人才离职率高怎么办？）"
                      @select="viewRelatedTitle"
                      style="width:100%;">
                      </el-autocomplete>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>问题背景</span>
                      </template>
                      <el-input v-model="form.background" type="textarea" autosize placeholder="描述问题发生的背景（如：公司发展阶段、行业特点、团队规模等）"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>现象描述</span>
                      </template>
                      <el-input v-model="form.phenomenon" type="textarea" autosize placeholder="详细描述问题的具体表现（如：过去半年内核心团队离职率达到30%）"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>可能导致的后果</span>
                      </template>
                      <el-input v-model="form.result" type="textarea" autosize placeholder="说明问题可能带来的负面影响（如：项目延期、团队士气低落）"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>可能的原因</span>
                      </template>
                      <el-input v-model="form.reason" type="textarea" autosize placeholder="列出你认为可能导致问题的原因（如：薪酬竞争力不足、缺乏职业发展路径）"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>解决目标</span>
                      </template>
                      <el-input v-model="form.target" type="textarea" autosize placeholder="你希望通过解决这个问题达到的具体目标（如：将离职率降低到10%以下）"></el-input>
                  </el-form-item>
                  <el-form-item>
                      <template slot="label">
                        <span style="color:#F56C6C;font-weight:bold;">*</span><span>已经采取的措施</span>
                      </template>
                      <el-input v-model="form.measure" type="textarea" autosize placeholder="已经采取的措施（如：提高了薪酬水平，但效果不明显）"></el-input>
                  </el-form-item>
                  <el-divider>以下为可选部分</el-divider>
                  <el-form-item label="企业规模">
                      <el-input v-model="form.scale" placeholder="示例：200人，年营业额1亿"></el-input>
                  </el-form-item>
                  <el-form-item label="行业类型">
                      <el-input v-model="form.industry_type" placeholder="示例：科技"></el-input>
                  </el-form-item>
                  <el-form-item label="发展阶段">
                      <el-input v-model="form.develop_stage" placeholder="示例：成长期"></el-input>
                  </el-form-item>
                  <el-form-item label="问题发生的时间">
                      <el-input v-model="form.occur_time" placeholder="示例：从2023年1月开始，持续至今"></el-input>
                  </el-form-item>
                  <el-form-item label="问题发生的部门">
                      <el-input v-model="form.occur_department" placeholder="示例：技术研发部"></el-input>
                  </el-form-item>
                  <el-form-item label="问题影响的范围">
                      <el-input v-model="form.impact_scope" placeholder="示例：影响3个核心项目的进度"></el-input>
                  </el-form-item>
                  <el-form-item label="频率和强度">
                      <el-input v-model="form.frequency" placeholder="示例：每月发生一次，影响较大"></el-input>
                  </el-form-item>
                  <el-form-item label="相关数据支持">
                      <el-input v-model="form.supporting_data" type="textarea" autosize placeholder="附上员工满意度调查报告"></el-input>
                  </el-form-item>
                  <el-form-item label="期望的解决方案">
                      <el-input v-model="form.expect_solution" placeholder="示例：希望从薪酬和职业发展两方面入手"></el-input>
                  </el-form-item>
                  <div style="padding-right:100px; margin-top:40px;">
                      <el-button type="primary" @click="submitUserQuestion">提交</el-button>
                  </div>
              </el-form>
            </div> 
          </div>
        </el-dialog>
        <!-- <el-dialog
          :visible.sync="dialogVisible"
          :fullscreen="true"
          :show-close="false"
          custom-class="fullscreen-dialog">
          <template #title>
            <div class="dialog-header">
              <span style="font-size:25px;">{{ cur_info.title }}</span>
              <el-button
                class="close-btn"
                icon="el-icon-close"
                @click="dialogVisible = false"
              ></el-button>
            </div>
          </template>

          <div class="dialog-body-custom">
            <div class="outer-div">
              <div class="middle-div">
                <div class="inner-div">
                  <div style="text-align:left;margin-left:20px;">
                    <span>更新时间：{{ cur_info.update_time }}    评分：{{ cur_info.avg_rating }}</span>
                  </div>
                  <div style="text-align:left;margin-left:20px;display:flex;margin-top:10px;">
                    <el-button type="text" icon="el-icon-star-off" v-if="!cur_info.isfavorite" @click="collect_painspot">收藏</el-button>
                    <el-button type="text" icon="el-icon-star-on" v-else @click="collect_painspot">收藏</el-button>
                    <el-button type="text" icon="el-icon-s-comment" style="margin-left:10px;" @click="rating_painspot">评分</el-button>
                    <el-rate
                      v-model="cur_info.rating"
                      show-score
                      allow-half
                      :disabled="cur_info.rating>0"
                      text-color="#ff9900"
                      style="margin-top:10px;margin-left:10px;"
                      v-show="show_rating || cur_info.rating > 0">
                    </el-rate>
                    <el-button type="text" icon="el-icon-share" style="margin-left:10px;">分享</el-button>
                    <el-button type="text" icon="el-icon-edit" style="margin-left:10px;" @click="editRichText">编辑</el-button>
                  </div>
                  <div class="ql-editor" v-html="content" style="margin-top:15px;" v-if="!isEdit"></div>
                  <div class="editor-container" style="margin-top:15px;" v-else>
                    <quill-editor
                      v-model="content"
                      ref="myQuillEditor"
                      :options="editorOptions" />
                    <el-button icon="el-icon-setting" type="primary" style="margin-top:10px;" @click="saveRichText">保存</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-dialog> -->
    </div>
  </div>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";

export default {
  components: { quillEditor },
  created() {
    let params = {
        task_type: "GLYF",
    }
    getdata.getListP("checklogin", params)
    .then(resp => {
          this.logged_role = resp.data.utype;
    })
    .catch(() => {
          this.logged_role = 'guest';
    })
    this.getSearchInfoList();
    if(this.$route.query.title){
      this.query_painpoint = this.$route.query.title;
      this.queryPainPoint('full');
    }else{
      this.getPainSpotList();
    }
  },
  data() {
    return {
      query_painpoint: '',
      dialogVisible: false,
      dialog_title: '',
      dialog_show_type: '',
      painspot_list: [],
      // painspot_list: [
      //   {id: 1, 'title': 'title1', 'desc': 'desc1', 'update_time': '2025/04/26', 'rank': '4.3/5', 'isfavorite': true, 'rating': 0, 'avg_rating': 2.4}, 
      //   {id: 2, 'title': 'title2', 'desc': 'desc2', 'update_time': '2025/04/25', 'rank': '4.9/5', 'isfavorite': false, 'rating': 4.5, 'avg_rating': 3.4}, 
      //   {id: 3, 'title': 'title3', 'desc': 'desc3', 'update_time': '2025/04/22', 'rank': '3.3/5', 'isfavorite': true, 'rating': 0, 'avg_rating': 4.4},
      //   {id: 4, 'title': 'title4', 'desc': 'desc4', 'update_time': '2025/04/23', 'rank': '3.4/5', 'isfavorite': false, 'rating': 0, 'avg_rating': 2.1},
      //   {id: 5, 'title': 'title5', 'desc': 'desc5', 'update_time': '2025/04/24', 'rank': '4.5/5', 'isfavorite': true, 'rating': 0, 'avg_rating': 1.4},
      //   {id: 6, 'title': 'title6', 'desc': 'desc6', 'update_time': '2025/04/22', 'rank': '4.4/5', 'isfavorite': false, 'rating': 3.5, 'avg_rating': 2.7},
      //   {id: 7, 'title': 'title7', 'desc': 'desc7', 'update_time': '2025/04/25', 'rank': '2.3/5', 'isfavorite': true, 'rating': 5, 'avg_rating': 4.8}],
      cur_info: {},
      show_rating: false,
      content: '',
      isEdit: false,
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'script': 'sub' }, { 'script': 'super' }],
            [{ 'indent': '-1' }, { 'indent': '+1' }],
            [{ 'direction': 'rtl' }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'font': [] }],
            [{ 'align': [] }],
            ['link'],
            ['clean']
          ]
        },
        placeholder: '请输入内容...',
        theme: 'snow',
      },
      content_permit: true,
      logged_role: 'guest',
      editor: null,
      toolbar: null,
      search_info_list: [],
      form: {},
    }
  },
  methods: {
    submitUserQuestion() {
      if(!this.form.title || !this.form.background || !this.form.phenomenon || !this.form.result || !this.form.reason || !this.form.target || !this.form.measure){
        this.$message({
          message: '必填项请填写完整！',
          type: "error",
          duration: 4000,
        })
        return;
      }
      postdata.postList("submitGLYFQuestion", JSON.stringify(this.form))
      .then(resp => {
          if(resp.data.code == 200){
            this.$message({
                message: resp.data.message,
                type: 'success',
            }) 
            this.dialogVisible = false;
            this.$router.push({
                path: '/glyf_user_center/my_questions',
            });                  
          }else{
            this.$message({
              message: resp.data.message,
              type: "error",
              duration: 6000,
            })
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    viewRelatedTitle(item) {
      let routeData = this.$router.resolve({
        path: '/glyf/main',
        query: {title: item.value}
      });
      window.open(routeData.href, '_blank');
    },
    getSearchInfoList() {
      getdata.getList("getSearchInfoList")
      .then(resp => {
          if(resp.data.code == 200){
              this.search_info_list = resp.data.data;                  
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    querySearchAsync(queryString, cb) {
      var search_info = this.search_info_list;
      var results = queryString ? search_info.filter(this.createStateFilter(queryString)) : search_info;
      cb(results);
    },
    createStateFilter(queryString) {
      return (query_painpoint) => {
        return (query_painpoint.value.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },    
    handleDialogOpened() {
      this.$nextTick(() => {
          // 新增粘贴事件监听
          const quill = this.$refs.myQuillEditor.quill;
          this.editor = quill.root;
          this.toolbar = quill.getModule('toolbar');
          this.editor.removeEventListener('paste', this.handlePasteImage);
          this.editor.addEventListener('paste', this.handlePasteImage);
          // 上传文件的监听
          this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
      })
    },
    handleDialogOpen() {
      this.isEdit = false;
    },
    getPainSpotList() {
      getdata.getList("getPainSpotSummary")
      .then(resp => {
          if(resp.data.code == 200){
              this.painspot_list = resp.data.data;                  
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    queryPainPoint(mode) {
      let params;
      params = {
        'query_info': this.query_painpoint,
        'mode': mode,
      }
      getdata.getListP("queryPainSpotSummary", params)
      .then(resp => {
          if(resp.data.code == 200){
              this.painspot_list = resp.data.data;                  
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    show_article_details(painspot) {
      this.cur_info = painspot;
      this.content = '';
      this.dialog_show_type = 'show_article_details';
      this.dialog_title = this.cur_info.title;
      this.getPainSpotContens('details', this.cur_info.id);
    },
    addPainPointQuestion() {
      this.dialog_title = '用户提问';
      this.dialog_show_type = 'add_pain_spot_question';
      this.dialogVisible = true;
    },
    getPainSpotContens(type, pid) {
      let params;
      params = {
          pid: pid,
          type: type,
      }
      
      getdata.getListP("getPainSpotContens", params)
      .then(resp => {
          if(resp.data.code == 200){
            this.content_permit = true;
            this.content = resp.data.data[0].content;
            this.dialogVisible = true;                  
          }else{
            this.content_permit = false;
            this.dialogVisible = true;
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    collect_painspot(type) {
      let params;
      params = {
          pid: this.cur_info.id,
          opt: type,
      }
      getdata.getListP("switchPainSpotFavorite", params)
      .then(resp => {
          if(resp.data.code == 200){
            if(this.cur_info.isfavorite=='是'){
              this.cur_info.isfavorite = '否';
            }else{
              this.cur_info.isfavorite = '是';
            }
            this.getPainSpotList();   // 修改收藏状态或是增加评分时，需要实时刷新痛点列表                  
          }else{
            this.$message({
              message: resp.data.message,
              type: "error",
              duration: 6000,
            })
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    rating_painspot() {
      if(this.cur_info.rating==0){
        this.show_rating = true;
      }
    },
    submitRating() {
      let params;
      params = {
          pid: this.cur_info.id,
          rate: this.cur_info.rating,
      }
      getdata.getListP("ratingPainSpot", params)
      .then(resp => {
          if(resp.data.code == 200){
            this.getPainSpotList();   // 修改收藏状态或是增加评分时，需要实时刷新痛点列表
          }else{
            this.$message({
              message: resp.data.message,
              type: "error",
              duration: 6000,
            })
          }
      })
      .catch(err => {
          console.log(err);
      });
    },
    shareRichText() {
      let params;
      params = {
          pid: this.cur_info.id,
      }
      getdata.getListP("addPainSpotShare", params)
      .then(resp => {
          if(resp.data.code == 200){
            this.$alert('分享页面地址(有效期7天)：' + resp.data.url, '分享成功', {
                confirmButtonText: '确定',
            });
          }else{
            this.$alert(resp.data.message, '错误', {
                confirmButtonText: '确定',
            });
          }
      })
      .catch(err => {
          console.log(err);
      }); 
    },
    editRichText() {
      // 启动编辑后需要同步修改后台状态(编辑中)和创建专家贡献记录
      let params;
      params = {
          pid: this.cur_info.id,
      }
      getdata.getListP("addExpertEdit", params)
      .then(resp => {
          if(resp.data.code == 200){
            this.isEdit = true;
          }else{
            this.$message({
              message: resp.data.message,
              type: "error",
              duration: 6000,
            })
          }
      })
      .catch(err => {
          console.log(err);
      });      
      this.$nextTick(() => {
        this.$refs.middleDiv.scrollTop = 0;
      })
    },
    saveRichText() {
      // 提交编辑后需要同步修改后台状态(审核中)
      let params;
      params = {
          pid: this.cur_info.id,
      }
      postdata.postListP("saveExpertEdit", JSON.stringify({'content': this.content}), params)
      .then(resp => {
          if(resp.data.code == 200){
            this.isEdit = false;
          }else{
            this.$message({
              message: resp.data.message,
              type: "error",
              duration: 6000,
            })
          }
      })
      .catch(err => {
          console.log(err);
      });     
      this.$nextTick(() => {
        this.$refs.middleDiv.scrollTop = 0;
      })
    },
    // 图片上传处理
    imageHandler() {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.click()
      
      input.onchange = async () => {
        const file = input.files[0]
        const formData = new FormData()
        formData.append('image', file)

        // 调用后端上传接口
        const { data } = await postdata.uploadFiles('uploadImages', formData)
        const quill = this.$refs.myQuillEditor.quill
        const range = quill.getSelection()
        quill.insertEmbed(range.index, 'image', data.url)
      }
    },
    // 新增粘贴图片处理方法
    async handlePasteImage(event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      let blob = null;

      for (const item of items) {
        if (item.type.indexOf('image') === 0) {
          blob = item.getAsFile();
          break;
        }
      }

      if (blob) {
        event.preventDefault();
        const formData = new FormData();
        formData.append('image', blob);
        
        try {
          const { data } = await postdata.uploadFiles('uploadImages', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
          
          const quill = this.$refs.myQuillEditor.quill;
          const range = quill.getSelection();
          quill.insertEmbed(range.index, 'image', data.url);
        } catch (error) {
          console.error('图片上传失败:', error);
        }
      }
    },
  },
  // mounted() {
    // 新增粘贴事件监听
    // const editor = this.$refs.myQuillEditor.quill.root;
    // editor.addEventListener('paste', this.handlePasteImage);
    // 销毁时移除监听
    // this.$once('hook:beforeDestroy', () => {
      // editor.removeEventListener('paste', this.handlePasteImage);
    // });
    // 上传文件的监听
    // this.$refs.myQuillEditor.quill.getModule('toolbar').addHandler('image', this.imageHandler);
  // },
}
</script>

<style scoped>
/* 【重要！】ql-editor 自带overflow，通过调整这里的height去自适应页面高度 */
.ql-editor {
  height: calc(100vh - 80px - 200px) !important;
}
::v-deep .editor-container .ql-editor {
  height: calc(100vh - 80px - 300px) !important;
}
::v-deep .el-form-item {
  margin-bottom: 5px;
}
.dialog-content /deep/ .el-input__inner {
  height: 33px;
}
.show_article_list {
  margin-top: 80px;
  overflow-y: auto;
  height: calc(100vh-155px);
}
</style>

<style>
.fullscreen-dialog {
  position: fixed;
  top: 75px !important; 
  left: 205px !important; 
  right: 5px !important;
  /* bottom: 5px !important; */
  height: calc(100vh - 80px) !important; /* 显式扣除 Header 以及上下多留的5px间隙 */
  width: auto !important;
  margin: 0 !important;
  max-width: none !important;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

/* 弹窗头部样式 */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  padding: 15px 20px;
}

/* 关闭按钮样式 */
.close-btn {
  padding: 5px;
  font-size: 18px;
  border: none;
  background: transparent;
}

/* 弹窗内容区域 */
.fullscreen-dialog .el-dialog__body {
  flex: 1;
  /* padding: 0 !important; */
  padding: 5px 20px;
  overflow: hidden;
}

/* 自定义内容容器 */
.dialog-content {
  height: 100%;
  /* overflow-y: auto; */
  /* padding: 20px; */
}

/* 内容区域高度适配 */
/* .dialog-content {
  height: calc(100vh - 70px - 90px);
  overflow: auto;
} */

.card_css:hover {
  cursor: pointer;
}

/* .el-dialog__body {
  padding: 5px 20px;
} */
</style>